import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { OptionSnackGroupComponent } from "../option-snack-group/option-snack-group.component";

@Component({
  selector: "lhpe-option-snack",
  templateUrl: "./option-snack.component.html",
  styleUrls: ["./option-snack.component.scss"],
})
export class OptionSnackComponent implements OnInit {
  @Input() option: any;
  @Input() nameProperty?: string;
  @Input() name?: string;
  @Input() disabled?: boolean;
  // Two types of snacks, default is 'removable', contains an x that can be disabled. Other is 'clickable'
  @Input() type?: string;
  @Input() color?: string;
  @Output() optionRemoved = new EventEmitter<any>();
  @Output() optionClicked = new EventEmitter<any>();

  constructor(
    @Inject(OptionSnackGroupComponent)
    private parent: OptionSnackGroupComponent,
  ) {}

  ngOnInit(): void {
    if (!this.type) {
      // If no specified type, inherit option group type, if no type defalt to removable
      this.type = this.parent?.type ?? "removable";
    }

    if (!this.color) {
      this.color = this.type === "clickable" ? "lightBlue" : "lightGreen";
    }
  }

  get text() {
    return (
      this.name ??
      (this.nameProperty ? this.option[this.nameProperty!] : this.option.name)
    );
  }

  removeOption() {
    this.optionRemoved.emit(this.option);
  }

  clickOption() {
    this.optionClicked.emit(this.option);
  }
}
